import { useMutation, useQuery } from '@tanstack/react-query';
import ApiClient from '../client';
import { ENDPOINTS } from '../endpoints';
import { queryKeys } from '../keys';
import { CreateCarrierIntegrationDto, UpdateCarrierIntegrationDto } from '../types';

const client = new ApiClient(process.env.API_URL!, 'app');

export const useCarriers = () =>
  useQuery({
    queryKey: queryKeys.carriers,
    queryFn: () => client.get(ENDPOINTS.CARRIERS),
  });

export const useCarrierIntegration = (id: string) =>
  useQuery({
    queryKey: queryKeys.carrierIntegrations(id),
    queryFn: () => client.get(ENDPOINTS.CARRIER_INTEGRATION(id)),
    enabled: !!id,
  });

export const useCreateCarrierIntegrations = () =>
  useMutation({
    mutationFn: (data: CreateCarrierIntegrationDto) => client.post(ENDPOINTS.CARRIER_INTEGRATIONS, data),
  });

export const useUpdateCarrierIntegration = () =>
  useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateCarrierIntegrationDto }) =>
      client.patch(ENDPOINTS.CARRIER_INTEGRATION(id), data),
  });

export const useDeleteCarrierIntegration = () =>
  useMutation({
    mutationFn: (id: string) => client.delete(ENDPOINTS.CARRIER_INTEGRATION(id)),
  });
